<template>
	<transition name="modal">
		<div class="modal" v-if="showModal">
			<div class="modal__backdrop">
				<div class="modal__wrapper">
					<button class="modal__close-btn" @click="closeModal()">
						<Icon name="close" />
						<span class="visually-hidden">Sluit</span>
					</button>
					<div class="modal__container">
						<div class="modal__header">
							<slot name="header">
								default header
							</slot>
						</div>
						<div ref="content" class="modal__body">
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import Icon from './Icon.vue';

export default {
  	name: 'Modal',
  	components: {
  	  Icon
  	},
	data() {
	    return {
	        showModal: false,
	        openClass: 'js-state-dialog-open'
	    };
	},
	mounted: function() {
		const FOCUSABLE_SELECTORS = 'input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled])';
		const openModalButton = document.getElementById('show-modal');
		const popupForm = document.getElementById('popup-form');

		openModalButton.addEventListener('click', () => {
			this.showModal = !this.showModal;

			this.$nextTick()
				.then(() => {
					const content = this.$refs.content;
					content.appendChild(popupForm);

					popupForm.querySelector(FOCUSABLE_SELECTORS).focus();

					document.documentElement.classList.add(this.openClass);
				});
		});
	},
	methods: {
		closeModal() {
			document.documentElement.classList.remove(this.openClass);
			
			this.showModal = !this.showModal;
		}
	}
};
</script>